import { render } from "./CguComponent.vue?vue&type=template&id=08f13e44&scoped=true"
import script from "./CguComponent.vue?vue&type=script&lang=js"
export * from "./CguComponent.vue?vue&type=script&lang=js"

import "./CguComponent.vue?vue&type=style&index=0&id=08f13e44&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f13e44"]])

export default __exports__